// @ts-nocheck
import { Pharmacy } from './models/Pharmacy';
import { flow, getRoot, Instance, types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { getEnvironment } from './utils';
import { Page } from '../common/enums';
import { RootStore } from './RootStore';
import { Datalist } from 'glamorous';
import { DutyAssignmentSearchCriteria } from './DutyAssignmentStore';

export const SearchCriteria = types.model({
  secretariatId: types.maybeNull(types.number),
  isActive: types.maybeNull(types.boolean),
});

export const PharmacyViews = {
  SIMPLE: 'SIMPLE',
  DETAILED: 'DETAILED',
};

export const PharmacyStore = types
  .compose(
    getBaseStore<Instance<typeof Pharmacy>, Instance<typeof Pharmacy>>(Pharmacy, 'pharmacyId', 'pharmacy'),
    types.model('PharmacyStore', {
      address: types.string,
      coordinates: types.model({ latitude: types.number, longitude: types.number }),
    }),
  )
  .views((self) => ({
    getPharmacyList() {
      return Datalist;
    },
    getByIdOrNew(id: number) {
      if (id > 0) {
        return self.datas.get(id.toString());
      } else {
        return {
          pharmacyId: undefined,
          isContributing: true,
          isActive: true,
          receivesSms: true,
        };
      }
    },
  }))
  .actions((self) => {
    const env = getEnvironment(self);
    const root: Instance<typeof RootStore> = getRoot(self);
    const apiFetcher = env.api;

    const updatePharmacyInStore = (pharmacy: Instance<typeof Pharmacy>) => {
      const pharmacyModel = Pharmacy.create(pharmacy);
      self.datas.put(pharmacyModel);
      return pharmacyModel;
    };

    const savePharmacy = flow(function*(pharmacy: Instance<typeof Pharmacy>) {
      const res = yield self.saveElement(pharmacy);
      // @ts-ignore
      if (pharmacy.pharmacyId !== res.pharmacyId) {
        // @ts-ignore
        root.ApplicationStore.navigate(`${Page.Pharmacies}/${res.pharmacyId}`);
      }
    });

    const search = flow(function*(criteria: Instance<typeof SearchCriteria>) {
      const result = yield apiFetcher.get('pharmacy', {
        params: {
          ...criteria,
          view: PharmacyViews.SIMPLE,
        },
      });
      const resultPharmacy: Array<Instance<typeof Pharmacy>> = [];
      // @ts-ignore
      result.forEach((node) => {
        const createdPharmacy = updatePharmacyInStore(node);
        resultPharmacy.push(createdPharmacy);
      });
      return resultPharmacy;
    });

    const loadAll = flow(function*() {
      const result = yield apiFetcher.get(`pharmacy/all`, {
        params: {
          view: PharmacyViews.SIMPLE,
        },
      });
      // @ts-ignore
      self.putInStore(result);
      // self.setDatasFromArray(result);
    });

    const loadNeighbors = flow(function*(pharmacyId: number) {
      const result = yield apiFetcher.get(`pharmacy/${pharmacyId}/neighbors`, {
        params: {
          view: PharmacyViews.SIMPLE,
        },
      });
      // @ts-ignore
      self.putInStore(result);
      // self.setDatasFromArray(result);
    });

    const searchForDutyAssignment = flow(function*(criteria: DutyAssignmentSearchCriteria) {
      const result = yield env.api.get('dutyAssignment/pharmacy', {
        params: {
          ...criteria,
          view: PharmacyViews.SIMPLE,
        },
      });

      self.putInStore(result!);
      // @ts-ignore
      const resultIds = result!.map((r) => r.pharmacyId);
      return self.dataList.filter((d) => resultIds.indexOf(d.pharmacyId) >= 0);
    });

    const getClosestPharmacyFrom = flow(function*(
      fromLatitude: number,
      fromLongitude: number,
      pharmacyIdToExclude: number | undefined = undefined,
    ) {
      const result = yield env.api.get('Pharmacy/closest', {
        params: { fromLatitude, fromLongitude, pharmacyIdToExclude },
      });
      return result;
    });

    const getPharmacyCountByMainMunicipality = flow(function*(municipalityINSCode: string) {
      const result = yield env.api.get(`pharmacy/getPharmacyCount`, {
        params: { municipalityINSCode },
      });
      return result;
    });

    return {
      savePharmacy,
      search,
      loadAll,
      loadNeighbors,
      searchForDutyAssignment,
      getClosestPharmacyFrom,
      getPharmacyCountByMainMunicipality,
    };
  });

export type PharmacyStoreType = typeof PharmacyStore.Type;
